import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CheckOutIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CheckOutIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M18.335 22H5.66519C4.20016 22 3.0083 20.8081 3.0083 19.3431V6.46886C3.0083 5.00384 4.20016 3.81198 5.66519 3.81198H18.335C19.8 3.81198 20.9919 5.00384 20.9919 6.46886V11.0613C20.9919 11.3435 20.7636 11.5718 20.4814 11.5718C20.1993 11.5718 19.971 11.3435 19.971 11.0613V6.46886C19.971 5.56662 19.2372 4.83286 18.335 4.83286H5.66519C4.76294 4.83286 4.02918 5.56662 4.02918 6.46886V19.3431C4.02918 20.2454 4.76294 20.9791 5.66519 20.9791H18.335C19.2372 20.9791 19.971 20.2454 19.971 19.3431V18.5136C19.971 18.2315 20.1993 18.0032 20.4814 18.0032C20.7636 18.0032 20.9919 18.2315 20.9919 18.5136V19.3431C20.9919 20.8081 19.8 22 18.335 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.4321 9.71096H3.56809C3.28595 9.71096 3.05765 9.48266 3.05765 9.20052C3.05765 8.91838 3.28595 8.69008 3.56809 8.69008H20.4321C20.7142 8.69008 20.9425 8.91838 20.9425 9.20052C20.9425 9.48266 20.7142 9.71096 20.4321 9.71096Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.1287 6.64432C15.8466 6.64432 15.6183 6.41602 15.6183 6.13388V2.51044C15.6183 2.2283 15.8466 2 16.1287 2C16.4109 2 16.6392 2.2283 16.6392 2.51044V6.13388C16.6392 6.41602 16.4109 6.64432 16.1287 6.64432Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.87095 6.64432C7.58881 6.64432 7.36051 6.41602 7.36051 6.13388V2.51044C7.36051 2.2283 7.58881 2 7.87095 2C8.15309 2 8.38139 2.2283 8.38139 2.51044V6.13388C8.38139 6.41602 8.15309 6.64432 7.87095 6.64432Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.4981 17.0431C16.3675 17.0431 16.2369 16.9932 16.1372 16.8935C15.9378 16.6941 15.9378 16.3711 16.1372 16.1717L17.9945 14.3144L16.1372 12.4571C15.9378 12.2577 15.9378 11.9347 16.1372 11.7353C16.3366 11.5359 16.6596 11.5359 16.859 11.7353L19.0772 13.9535C19.2766 14.1529 19.2766 14.4759 19.0772 14.6753L16.859 16.8935C16.7593 16.9932 16.6287 17.0431 16.4981 17.0431Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.7163 14.8249H12.3288C12.0467 14.8249 11.8184 14.5966 11.8184 14.3144C11.8184 14.0323 12.0467 13.804 12.3288 13.804H18.7163C18.9985 13.804 19.2268 14.0323 19.2268 14.3144C19.2268 14.5966 18.9985 14.8249 18.7163 14.8249Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CheckOutIcon;
